import React, { FC } from 'react';
import styled, { css } from 'styled-components/macro';

import Typography from 'components/Typography';
import { ColorVariants, SpaceVariants } from 'theme';
import media from 'helpers/media';

export type SectionTitleProps = {
    /** Text that will be displayed as a h3 tag */
    title: string;

    /** Optional description */
    description?: string;

    /** Text alignment */
    align?: 'left' | 'center' | 'right';

    /** Text color */
    color?: ColorVariants;

    spaceBottom?: SpaceVariants;
};

const Root = styled.div<{
    $align?: 'left' | 'right' | 'center';
    $color?: ColorVariants;
}>`
    margin-bottom: ${({ theme }) => theme.space.xlarge};
    text-align: ${({ $align }) => ($align ? $align : 'inherit')};

    &:last-child {
        margin-bottom: 0;
    }

    ${({ theme }) => media.mobile` 
        margin-bottom: ${theme.space.base};
        &:last-child {
            margin-bottom: 0;
        }
    `}

    ${({ $color, theme }) =>
        $color &&
        css`
            color: ${theme.colors[$color]};
        `};
`;

const Description = styled.p`
    margin-top: ${({ theme }) => theme.space.base};
    &:first-child {
        margin-top: 0;
    }
`;

const SectionTitle: FC<
    SectionTitleProps & React.HTMLAttributes<HTMLDivElement>
> = ({ title, align = 'left', color, description, spaceBottom, ...rest }) => (
    <Root $align={align} $color={color} {...rest}>
        {title && (
            <Typography
                variant="h2"
                spaceBottom={spaceBottom}
                dangerouslySetInnerHTML={{ __html: title }}
            />
        )}
        {description && (
            <Description dangerouslySetInnerHTML={{ __html: description }} />
        )}
    </Root>
);

export default SectionTitle;
